<template>
  <fieldset class="border rounded p-3">
    <legend>Add keyword</legend>
    <form method="post">
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label for="keyword">Keyword:</label>
            <input type="text" class="form-control" v-model="Keyword" />
          </div>
        </div>
      </div>
      <div class="form-group">
        <input
          type="button"
          value="Save"
          class="btn btn-primary"
          :disabled="Loading"
          @click="saveKeyword"
        />
      </div>
    </form>
  </fieldset>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "saveKeywords",
  data() {
    return {
      Keyword: "",
      Loading: false,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
  },
  computed: {
    getExcludedKeywordsData() {
      return this.$store.getters["excludedKeywords/getExcludedKeywordsData"];
    },
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "excludedKeywords",
        activeMenu: this.activeMenu ? this.activeMenu : "productandsuppliers",
      });
    },

    saveKeyword() {
      if (this.Keyword === "") return;
      this.Loading = true;
      let Keyword = this.Keyword;
      this.Keyword = "";
      this.$store
        .dispatch("excludedKeywords/addExcludedKeyword", {
          keyword: Keyword,
        })
        .then(() => {
          this.Loading = false;
          alert("Keyword added to excluded keywords list");
          this.$store.dispatch("excludedKeywords/getExcludedKeywords", {
            searchTerm: "",
            pageNumber: this.getExcludedKeywordsData.pageNumber,
            pageSize: this.getExcludedKeywordsData.pageSize,
            sortField: this.getExcludedKeywordsData.sortField,
            sortOrder: this.getExcludedKeywordsData.sortOrder,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
